import { render, staticRenderFns } from "./Game4-4.vue?vue&type=template&id=50a0679d&scoped=true&"
import script from "./Game4-4.vue?vue&type=script&lang=js&"
export * from "./Game4-4.vue?vue&type=script&lang=js&"
import style0 from "./Game4-4.vue?vue&type=style&index=0&id=50a0679d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0679d",
  null
  
)

export default component.exports